import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MessageSquare, ArrowRight } from "lucide-react";
import Navbar from "../components/Navbar";
import SiteFooter from "../components/SiteFooter";

const ContactPage: React.FC = () => {
  return (
    <div style={{ background: "var(--nx-navy)", minHeight: "100vh" }}>
      <Navbar variant="solid" />

      <section style={{ padding: "160px 5% 100px", maxWidth: 900, margin: "0 auto" }}>
        <span className="nx-badge nx-badge-blue" style={{ marginBottom: 20 }}>
          <MessageSquare size={11} /> Get in Touch
        </span>
        <h1
          style={{
            fontFamily: "Syne, sans-serif",
            fontSize: "clamp(28px, 4vw, 44px)",
            fontWeight: 800,
            color: "#fff",
            letterSpacing: "-0.03em",
            marginBottom: 16,
          }}
        >
          Talk to the Nexora team
        </h1>
        <p
          style={{
            fontSize: 15,
            color: "rgba(255,255,255,0.55)",
            lineHeight: 1.8,
            maxWidth: 620,
            marginBottom: 48,
          }}
        >
          Whether you're evaluating Nexora for your community, need help with
          an existing account, or want to discuss an Enterprise rollout across
          multiple societies, we're happy to help.
        </p>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 20,
            marginBottom: 48,
          }}
        >
          <div className="nx-card-dark" style={{ padding: 24, background: "rgba(255,255,255,0.03)" }}>
            <Mail size={18} style={{ color: "var(--nx-blue-light)", marginBottom: 10 }} />
            <h3 style={{ fontSize: 14, fontWeight: 700, color: "#fff", marginBottom: 6 }}>
              Email
            </h3>
            <a
              href="mailto:nexora@pentagonanalytics.io"
              style={{ fontSize: 13, color: "rgba(255,255,255,0.6)" }}
            >
              nexora@pentagonanalytics.io
            </a>
          </div>
          <div className="nx-card-dark" style={{ padding: 24, background: "rgba(255,255,255,0.03)" }}>
            <Phone size={18} style={{ color: "var(--nx-blue-light)", marginBottom: 10 }} />
            <h3 style={{ fontSize: 14, fontWeight: 700, color: "#fff", marginBottom: 6 }}>
              Sales & Support
            </h3>
            <span style={{ fontSize: 13, color: "rgba(255,255,255,0.6)" }}>
              Available Mon–Sat, 9am–7pm IST
            </span>
          </div>
        </div>

        <div
          className="nx-card-dark"
          style={{
            padding: 32,
            background: "rgba(26,108,246,0.06)",
            border: "1px solid rgba(26,108,246,0.2)",
            textAlign: "center",
          }}
        >
          <h2 style={{ fontSize: 18, fontWeight: 700, color: "#fff", marginBottom: 10 }}>
            Ready to bring Nexora to your community?
          </h2>
          <p style={{ fontSize: 13, color: "rgba(255,255,255,0.5)", marginBottom: 20 }}>
            Share a few details and our team will reach out within one business day.
          </p>
          <Link to="/request-access" className="nx-btn nx-btn-primary nx-btn-lg">
            Request Access
            <ArrowRight size={16} />
          </Link>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
};

export default ContactPage;
